import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { GameComponent } from '../game/game.component';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MessageType } from '../shared/model/message-type';
import { Message } from '../shared/model/message';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ScattergoryVote } from '../shared/model/scattergory';
import { GameStatus } from '../shared/model/game-status';

@Component({
  selector: 'pbg-scattergories',
  templateUrl: './scattergories.component.html',
  styleUrls: ['./scattergories.component.scss']
})
export class ScattergoriesComponent extends GameComponent implements OnInit {
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  /* Submit Mode Variables */
  submitMode = false;
  letter: string;
  categories: string[];
  expiration: number;
  timeLimit: number;
  submissions: any = {};

  /* Wait Mode Variables */
  waitMode = false;

  /* Vote Mode Variables */
  voteMode = false;
  votes: ScattergoryVote[] = [];
  voteSubmissions: any = {};
  voteModeSubmissions: any = {};
  submitterNames: string[] = [];

  constructor(
    socketService: SocketService,
    cookieService: CookieService,
    router: Router,
    resolver: ActivatedRoute,
    public httpClient: HttpClient,
    public cdr: ChangeDetectorRef
  ) {
    super(socketService, cookieService, router, resolver);
  }

  messageHandler(message: Message) {
    if (
      (message.action === MessageType.Prompt ||
        message.content.status === GameStatus.InProgress) &&
      !this.categories
    ) {
      this.waitMode = false;
      this.showReady = false;
      this.showWaiting = false;

      this.letter = message.content.letter;
      this.voteSubmissions = message.content.submissions;
      this.categories = message.content.cattergories;

      this.expiration = message.content.expiration;
      this.timeLimit = message.content.timeLimit;

      if (message.content.voteMode) {
        this.buildVoteMode();
      } else {
        this.buildSubmitMode();
      }
    }
  }

  sendResponse(message: string): void {
    const submission = {
      answer: message,
      submitMode: this.submitMode,
      voteMode: this.voteMode
    };

    this.submitMode = false;
    this.voteMode = false;
    this.waitMode = true;
    this.categories = null;

    this.socketService.send({
      from: this.user,
      content: submission,
      action: MessageType.Response,
      gameId: this.gameId
    });
  }

  addSubmission(event, category) {
    const inputDOM = event.input;
    const word = event.value.toLowerCase().trim();

    if (
      this.submissions[category].length < 3 &&
      !this.submissions[category].includes(word) &&
      word !== ''
    ) {
      this.submissions[category].push(word);
    }

    if (inputDOM) {
      inputDOM.value = '';
    }

    this.cdr.detectChanges();
  }

  removeSubmission(submittedWord, category) {
    const index = this.submissions[category].indexOf(submittedWord);

    if (index >= 0) {
      this.submissions[category].splice(index, 1);
    }

    this.cdr.detectChanges();
  }

  buildVoteMode() {
    this.submitterNames = Object.keys(this.voteSubmissions).filter(name => {
      return name !== this.user.name;
    });

    for (let i = 0; i < this.submitterNames.length; i++) {
      const submitter = this.submitterNames[i];

      for (let a = 0; a < this.categories.length; a++) {
        const cat = this.categories[a];

        this.voteSubmissions[submitter].submission[cat].forEach(submission => {
          submission.voterName = this.user.name;

          if (!this.voteModeSubmissions[submission.category]) {
            this.voteModeSubmissions[submission.category] = [];
          }

          this.voteModeSubmissions[submission.category].push(submission);
        });
      }
    }

    this.submitMode = false;
    this.voteMode = true;
  }

  buildSubmitMode() {
    this.categories.forEach(cat => {
      this.submissions[cat] = [];
    });

    this.submitMode = true;
    this.voteMode = false;
  }

  submitSubmissions() {
    this.sendResponse(this.submissions);
  }

  submitVote() {
    this.sendResponse(this.voteModeSubmissions);
  }

  timerChangeHandler(event) {
    if (event.status.ended) {
      if (this.voteMode) {
        this.submitVote();
      } else {
        this.submitSubmissions();
      }
    }
  }
}
